<template>
  <div class="personal-page">
    <div class="column column-left">
      <pc-block>
        <pc-personal-data />
      </pc-block>
      <pc-block>
        <pc-password-change />
      </pc-block>
    </div>
    <div class="column column-right">
      <pc-block>
        <pc-verification-way />
      </pc-block>
    </div>
  </div>
</template>

<script>
import PcBlock from '@/components/views/PrivateCabinet/PcBlock'
import PcPersonalData from '@/components/views/PrivateCabinet/PcPersonalData'
import PcPasswordChange from '@/components/views/PrivateCabinet/PcPasswordChange'
import PcVerificationWay from '@/components/views/PrivateCabinet/PcVerificationWay'

export default {
  name: 'PcProfile',
  components: {
    PcVerificationWay, PcPasswordChange, PcPersonalData, PcBlock
  }
}
</script>

<style scoped lang="scss">


</style>
